import { render } from "./ModalThankYou.vue?vue&type=template&id=6b74402d"
import script from "./ModalThankYou.vue?vue&type=script&lang=js"
export * from "./ModalThankYou.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__